// UtcDateTimeInput.js
import { DateTimeInput } from 'react-admin';

const UtcDateTimeInput = (props) => {
    const convertToLocalInputValue = (isoDateStr) => {
        if (!isoDateStr) return '';
        const date = new Date(isoDateStr);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hour = String(date.getUTCHours()).padStart(2, '0');
        const minute = String(date.getUTCMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hour}:${minute}`;
    };

    const convertToUtcISOString = (value) => {
        const date = new Date(value);
        return new Date(
            Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                date.getHours()+2,
                date.getMinutes()
            )
        ).toISOString();
    };

    return (
        <DateTimeInput
            {...props}
            parse={convertToUtcISOString}
            format={convertToLocalInputValue}
        />
    );
};

export default UtcDateTimeInput;
